<template>
  <p v-if="loading">Loading...</p>
  <div class="c-iframe" :class="{ admin: isAdmin }" v-else>
    <iframe
      class="c-iframe__frame"
      :src="iframeSrc"
      loading="lazy"
      width="100%"
      :height="iframeHeight"
      ref="iframeContent"
      @mouseover="lockParent"
      @mouseout="unlockParent"
    />
  </div>
</template>

<script>
export default {
  name: "BaseIframe",
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    lockParent() {
      if (!this.isAdmin) {
        document.getElementsByTagName("body")[0].classList.add("noscroll-imp");
      }
    },
    unlockParent() {
      if (!this.isAdmin) {
        document.getElementsByTagName("body")[0].classList.remove("noscroll-imp");
      }
    },
  },
  props: {
    iframeSrc: {
      type: String,
      default: null,
    },
    iframeHeight: {
      type: [String, Number],
      default: 450,
    },
  },
  computed: {
    isAdmin() {
      return this.$route.meta.isAdmin;
    },
  },
  mounted() {
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.c-iframe {
  position: relative;
  &__frame {
    border: 0;
    z-index: 5;
  }

  &.admin & {
    &__frame {
      pointer-events: none;
    }
  }
}
</style>
